import React from "react";

/**
 * Link icona Telegram riutilizzabile.
 * - href: URL del canale/chat Telegram.
 * - title: testo accessibile/tooltip per l'icona.
 * - className: classi aggiuntive per dimensioni/stili.
 */
export interface TelegramIconLinkProps {
  href: string;
  title?: string;
  className?: string;
  iconClassName?: string; // classi per dimensionare/stilizzare l'SVG
}

const TelegramIconLink: React.FC<TelegramIconLinkProps> = ({
  href,
  title = "Telegram",
  className,
  iconClassName,
}) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={title}
      title={title}
      className={`hover:opacity-60 transition-opacity flex items-center justify-center w-full h-full ${
        className ?? ""
      }`.trim()}
    >
      {/* SVG ufficiale stile semplice */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className={`${
          iconClassName ?? "h-8 sm:h-8"
        } text-[#fff] block translate-y-[-2px]`.trim()}
      >
        <path d="M9.04 15.314 8.9 18.29c.286 0 .41-.123.56-.27l1.345-1.29 2.79 2.04c.51.28.87.133 1.01-.47l1.83-8.59c.19-.86-.32-1.2-.86-.99l-10.71 4.14c-.82.32-.81.78-.14.99l2.74.86 6.35-4.01c.3-.2.57-.09.35.11l-5.14 4.85z" />
      </svg>
    </a>
  );
};

export default TelegramIconLink;
